__turbopack_context__.v({
  "actions": "DisclaimerModal-module__u2ab-G__actions",
  "backdrop": "DisclaimerModal-module__u2ab-G__backdrop",
  "close": "DisclaimerModal-module__u2ab-G__close",
  "content": "DisclaimerModal-module__u2ab-G__content",
  "fadeIn": "DisclaimerModal-module__u2ab-G__fadeIn",
  "header": "DisclaimerModal-module__u2ab-G__header",
  "modal": "DisclaimerModal-module__u2ab-G__modal",
  "primaryButton": "DisclaimerModal-module__u2ab-G__primaryButton",
  "title": "DisclaimerModal-module__u2ab-G__title",
});
